import { render, staticRenderFns } from "./RiderStatus.vue?vue&type=template&id=11d48bc8&scoped=true&"
import script from "./RiderStatus.vue?vue&type=script&lang=js&"
export * from "./RiderStatus.vue?vue&type=script&lang=js&"
import style0 from "./RiderStatus.vue?vue&type=style&index=0&id=11d48bc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d48bc8",
  null
  
)

export default component.exports